import { render } from "./headSpace.vue?vue&type=template&id=49539286&scoped=true&lang=html"
import script from "./headSpace.vue?vue&type=script&lang=js"
export * from "./headSpace.vue?vue&type=script&lang=js"

import "./headSpace.vue?vue&type=style&index=0&id=49539286&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49539286"]])

export default __exports__